module.exports = __webpack_public_path__ + "img/weddings_23_H.67e65d75.webp";